import { css } from '@emotion/core';
import helperUtils from '../utils/helper.util';

const centerContentColumn = theme => css`
display: ${
  helperUtils.checkBrowser('ie')
    ? `
   ms-inline-flexbox;
  `
    : 'inline-flex;'
}
  flex-direction: column;
  justify-content: center;'
`;

const statusBadgeStyle = () => css`
  
  display: ${
    helperUtils.checkBrowser('ie')
      ? `
   ms-inline-flexbox;
  `
      : 'block'
  }
  flex-direction: row;
  align-items: flex-start;
  padding: 4px;
`;

export default {
  centerContentColumn,
  statusBadgeStyle
};
